module.exports = __webpack_public_path__ + "static/media/exit-ic-light-blue.ea0d77fd.svg";